import jwtService from "services/jwtService";
import { setUserData } from "./user.actions";

export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export function submitLogin({ login, password, captcha, onSuccess, onError }) {
  return (dispatch) => {
    dispatch({
      type: LOGIN_START,
    });
    jwtService
      .signInWithUsername({ login, password, captcha })
      .then((user) => {
        dispatch(setUserData(user));
        onSuccess();
        return dispatch({
          type: LOGIN_SUCCESS,
        });
      })
      .catch((error) => {
        onError();
        return dispatch({
          type: LOGIN_ERROR,
          payload: error,
        });
      });
  };
}
